import React from "react";
import PropConfigDetail from "../component/PropConfig";

const PropContainerDetailContainer = () => (<PropConfigDetail />)

export default PropContainerDetailContainer;
